module.exports = __webpack_public_path__ + "static/media/paint3.9409d39b.jpg";